// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__KX3MW","label":"LabeledBox_label__3D6fg"};